// removed by extract-text-webpack-plugin
module.exports = {"root":"loading-spinner__root","spin":"loading-spinner__spin","spinAfter":"loading-spinner__spinAfter"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/loading-spinner/styles.less
// module id = 165
// module chunks = 1 2